import { render, staticRenderFns } from "./editVehicleFuleDetails.vue?vue&type=template&id=084adea2"
import script from "./editVehicleFuleDetails.vue?vue&type=script&lang=js"
export * from "./editVehicleFuleDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports